import React, { FC } from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { QuoteObj, UserObj, Overwrite } from "../../../../GlobalTypes";
import { styled } from "@mui/material/styles";
import useToolbarProdSelector from "./useToolbarProdSelector";

export type AdminQuoteObj = Overwrite<QuoteObj, { userId: UserObj }>;

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(1),
  color: "#4b4b4b",
}));

const StyledDivRow = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  position: "relative",
});

const StyledDivRowEndWide = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  width: "300%",
});

const StyledDivRowEndCenter = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  width: "100%",
});

interface TableToolbarProdProps {
  numSelected: number;
  quote: AdminQuoteObj;
  unCheckAll: () => void;
}

const TableToolbarProd: FC<TableToolbarProdProps> = ({
  numSelected,
  quote,
  unCheckAll,
}) => {
 const {
  handleClickLabels,
    handleClickShipLabels,
    loadCnc,
    loadShipLabel,
 } = useToolbarProdSelector(quote, numSelected)

  return (
    <>
      <StyledToolbar
        style={{ backgroundColor: numSelected > 0 ? "#57d5f2" : "" }}
      >
        <StyledDivRow>
          {numSelected > 0 && (
            <>
              <Typography
                style={{ flex: "1 1 100%" }}
                color="inherit"
                variant="subtitle1"
                component="div"
              >
                {numSelected} selected
              </Typography>
              <button
                onClick={unCheckAll}
                style={{ position: "absolute", left: 100, borderRadius: 5 }}
              >
                Un-Check All
              </button>
            </>
          )}

          <StyledDivRowEndWide>
            <StyledDivRowEndCenter>
              {numSelected === 1 && (
                <>
                  {quote.salesOrder && quote.salesOrder !== "N/A" && (
                    <>
                      <div style={{ padding: 5 }}>
                        {!loadCnc ? (
                          <Button
                            size="small"
                            color="primary"
                            style={{ fontSize: 11, color: "white" }}
                            variant="contained"
                            onClick={() =>
                              handleClickLabels(quote?.salesOrder || "")
                            }
                          >
                            CNC Labels
                          </Button>
                        ) : (
                          <Button
                            size="small"
                            color="primary"
                            style={{ fontSize: 11, color: "white" }}
                            variant="contained"
                            disabled={true}
                          >
                            Generating...
                          </Button>
                        )}
                      </div>

                      <div style={{ padding: 5 }}>
                        {!loadShipLabel ? (
                          <Button
                            size="small"
                            style={{ fontSize: 11, color: "white" }}
                            variant="contained"
                            color="primary"
                            onClick={handleClickShipLabels}
                          >
                            Shipping Labels
                          </Button>
                        ) : (
                          <Button
                            size="small"
                            style={{ fontSize: 11, color: "white" }}
                            variant="contained"
                            color="primary"
                            disabled={true}
                          >
                            Generating...
                          </Button>
                        )}
                      </div>
                    </>
                  )}
                </>
              )}
            </StyledDivRowEndCenter>
          </StyledDivRowEndWide>
        </StyledDivRow>
      </StyledToolbar>
    </>
  );
};

export default TableToolbarProd;
